import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";  
import SubscribeForNotification from "../Subscribe/subscribe";
import localHomepageData from "../../Pages/HomePage/homepage.json"; // Local fallback
import "./index.css";
import parse from "html-react-parser";  
 
const CustomFooter = () => {
  const [footerData, setFooterData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const imgURL = process.env.REACT_APP_CDN_PATH + "hotel/flordeindia/images/homepage/";
  
  const jsonCDNURL = process.env.REACT_APP_CDN_PATH + "hotel/flordeindia/includes/homepage.json";
 
  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        setLoading(true); 
        setError(false);
 
        const response = await fetch(`${jsonCDNURL}?v=${Date.now()}`);

        if (!response.ok) {
          throw new Error(`CDN fetch failed with status: ${response.status}`);
        }

        const jsonData = await response.json();

        // Validate that we have footer data
        if (!jsonData || !jsonData.footer) {
          throw new Error('Footer data not found in CDN response');
        }

        setFooterData(jsonData.footer);

      } catch (cdnError) {
        console.warn('CDN fetch failed, using local fallback:', cdnError.message);

        try {
          // Use local fallback data
          if (localHomepageData && localHomepageData.footer) {
            setFooterData(localHomepageData.footer);
            setError(false);
           } else {
            throw new Error('Local footer data is invalid');
          }

        } catch (localError) {
          console.error('Both CDN and local data loading failed:', localError);
          setError(true);
          setFooterData(null);
        }

      } finally {
        setLoading(false);
      }
    };

    fetchFooterData();
  }, [ ]);

  // Show loading state (optional - you might want to show a skeleton or nothing)
  if (loading) {
    return (
      <footer className="flor-footer-wrapper">
        <Container>
          <Row>
            <Col>
              <div className="flor-footer-loading">Loading footer...</div>
            </Col>
          </Row>
        </Container>
      </footer>
    );
  }

  // Return null if no data is available or there's an error
  if (error || !footerData) {
    console.error('Footer data not available');
    return null;
  }

  return (
    <footer className="flor-footer-wrapper">
      <Container>
        <Row className="flor-footer-content">
          {/* Left Section - Logo and Links */}
          <Col lg={5} md={12} sm={12} className="flor-footer-left">
          {footerData.logo && (
            <div className="flor-footer-logo-block">
              <Link to="/">
                <img
                  src={imgURL + footerData.logo.filename}
                  alt={footerData.logo.alt}
                  className="flor-footer-logo"
                />
              </Link>
            </div>
          )}

            {footerData.links && footerData.links.length > 0 && (
              <div className="flor-footer-links">
                {footerData.links.map((link, index) => {
                  // Check if it's an external link
                  if (link.external) {
                    return (
                      <a
                        key={index}
                        href={link.url}
                        className="flor-footer-link"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {parse(link.text)}
                      </a>
                    );
                  } else {
                    // Use React Router Link for internal navigation
                    return (
                      <Link
                        key={index}
                        to={link.url}
                        className="flor-footer-link"
                      >
                        {parse(link.text)}
                      </Link>
                    );
                  }
                })}
              </div>
            )}
            
            <div className="footer-text">
              <p>{parse(footerData.text1)}<br/>
              {parse(footerData.text2)}<br/>
              {footerData.phone && parse(footerData.phone)}<br/>
              {parse(footerData.text3)}</p>
            </div>

          </Col>

          {/* Right Section - Subscribe Component */}
          <Col lg={7} md={12} sm={12} className="flor-footer-right">
            <SubscribeForNotification />
          </Col>
        </Row>

        {/* Copyright Section */}
        {/* {footerData.copyright && (
          <Row>
            <Col xs={12}>
              <div className="flor-copyright-section">
                <p className="flor-copyright-text">{footerData.copyright}</p>
              </div>
            </Col>
          </Row>
        )} */}
      </Container>
    </footer>
  );
};

export default CustomFooter;